var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var ClusterIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 60,
    glyphHeight: 60
  }), React.createElement("path", {
    d: "M30 21.6522C25.4087 21.6522 21.6522 25.4087 21.6522 30C21.6522 34.5914 25.4087 38.3479 30 38.3479C34.5914 38.3479 38.3479 34.5914 38.3479 30C38.3479 25.4087 34.5914 21.6522 30 21.6522Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M30 9.13049C27.7043 9.13049 25.826 11.0088 25.826 13.3044C25.826 15.6001 27.7043 17.4783 30 17.4783C32.2956 17.4783 34.1739 15.6001 34.1739 13.3044C34.1739 11.0088 32.2956 9.13049 30 9.13049Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M30 42.5217C27.7043 42.5217 25.826 44.4 25.826 46.6956C25.826 48.9913 27.7043 50.8696 30 50.8696C32.2956 50.8696 34.1739 48.9913 34.1739 46.6956C34.1739 44.4 32.2956 42.5217 30 42.5217Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M30 0.782593C28.7479 0.782593 27.9131 1.61738 27.9131 2.86955C27.9131 4.12172 28.7479 4.95651 30 4.95651C31.2522 4.95651 32.087 4.12172 32.087 2.86955C32.087 1.61738 31.2522 0.782593 30 0.782593Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M30 55.0435C28.7479 55.0435 27.9131 55.8782 27.9131 57.1304C27.9131 58.3826 28.7479 59.2174 30 59.2174C31.2522 59.2174 32.087 58.3826 32.087 57.1304C32.087 55.8782 31.2522 55.0435 30 55.0435Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M15.1826 15.1826C13.513 16.8522 13.513 19.3565 15.1826 21.0261C16.8522 22.6956 19.3565 22.6956 21.0261 21.0261C22.6956 19.3565 22.6956 16.8522 21.0261 15.1826C19.5652 13.513 16.8522 13.513 15.1826 15.1826Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M38.7652 38.7652C37.0957 40.4348 37.0957 42.9391 38.7652 44.6087C40.4348 46.2782 42.9391 46.2782 44.6087 44.6087C46.2783 42.9391 46.2783 40.4348 44.6087 38.7652C43.1478 37.3043 40.4348 37.3043 38.7652 38.7652Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M9.3391 9.3391C8.50432 10.1739 8.50432 11.4261 9.3391 12.2608C10.1739 13.0956 11.4261 13.0956 12.2608 12.2608C13.0956 11.4261 13.0956 10.1739 12.2608 9.3391C11.4261 8.50432 10.1739 8.50432 9.3391 9.3391Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M47.7391 47.7391C46.9043 48.5739 46.9043 49.8261 47.7391 50.6609C48.5739 51.4957 49.8261 51.4957 50.6609 50.6609C51.4957 49.8261 51.4957 48.5739 50.6609 47.7391C49.8261 46.9043 48.5739 46.9043 47.7391 47.7391Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M9.13049 30C9.13049 32.2956 11.0088 34.1739 13.3044 34.1739C15.6001 34.1739 17.4783 32.2956 17.4783 30C17.4783 27.7043 15.6001 25.826 13.3044 25.826C11.0088 25.826 9.13049 27.7043 9.13049 30Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M42.5217 30C42.5217 32.2956 44.4 34.1739 46.6956 34.1739C48.9913 34.1739 50.8696 32.2956 50.8696 30C50.8696 27.7043 48.9913 25.826 46.6956 25.826C44.4 25.826 42.5217 27.7043 42.5217 30Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M0.782593 30C0.782593 31.2522 1.61738 32.087 2.86955 32.087C4.12172 32.087 4.95651 31.2522 4.95651 30C4.95651 28.7479 4.12172 27.9131 2.86955 27.9131C1.61738 27.9131 0.782593 28.7479 0.782593 30Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M55.0435 30C55.0435 31.2522 55.8782 32.087 57.1304 32.087C58.3826 32.087 59.2174 31.2522 59.2174 30C59.2174 28.7479 58.3826 27.9131 57.1304 27.9131C55.8782 27.9131 55.0435 28.7479 55.0435 30Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M15.1826 44.8173C16.8522 46.4869 19.3565 46.4869 21.0261 44.8173C22.6956 43.1478 22.6956 40.6434 21.0261 38.9739C19.3565 37.3043 16.8522 37.3043 15.1826 38.9739C13.513 40.4347 13.513 43.1478 15.1826 44.8173Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M38.7652 21.2348C40.4348 22.9044 42.9391 22.9044 44.6087 21.2348C46.2783 19.5652 46.2783 17.0609 44.6087 15.3913C42.9391 13.7218 40.4348 13.7218 38.7652 15.3913C37.3043 16.8522 37.3043 19.5652 38.7652 21.2348Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M9.3391 50.6609C10.1739 51.4957 11.4261 51.4957 12.2608 50.6609C13.0956 49.8261 13.0956 48.5739 12.2608 47.7391C11.4261 46.9043 10.1739 46.9043 9.3391 47.7391C8.50432 48.5739 8.50432 49.8261 9.3391 50.6609Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M47.7391 12.2608C48.5739 13.0956 49.8261 13.0956 50.6609 12.2608C51.4957 11.4261 51.4957 10.1739 50.6609 9.3391C49.8261 8.50432 48.5739 8.50432 47.7391 9.3391C46.9043 10.1739 46.9043 11.4261 47.7391 12.2608Z",
    fill: "black"
  }));
};
export var ClusterIconGlyph = function (props) {
  return React.createElement(ClusterIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};